import {
  IonGrid,
  IonRow,
  IonCol,
  IonCard,
  IonItem,
  IonLabel,
  IonButton,
  IonIcon,
  useIonViewWillEnter,
} from "@ionic/react";
import { briefcaseOutline, documentTextOutline, personOutline } from "ionicons/icons";
import { useEffect, useState } from "react";
import api from "../../../utils/api";
import {setUserCount} from "../../../store/documentShow/index"
import { useDispatch, useSelector } from "react-redux";
import { selectUser } from "../../../store/userAuthentication/selectors/selectUser";
import axiosInstance from "../../../utils/axiosConfig";


export const UsersKpis: React.FC = () => {
  const user = useSelector(selectUser);
  const dispatch = useDispatch()
  const [counters, setCounters] = useState<
    { name: string; counter?: string; link?: string; icon: any }[]
  >([
    {
      name: "Usuarios",
      counter: "0",
      link: "/app/rrhh/usuarios",
      icon: personOutline,
    },
    {
      name: "Acuerdos",
      counter: "0",
      link: "/app/rrhh/acuerdos",
      icon: documentTextOutline,
    },
    {
      name: "Mi DT",
      counter: "0",
      link: "/app/rrhh/mi-dt",
      icon: briefcaseOutline,
    },
  ]);

  const fetchKpis = async () => {
    const [{ data: usersCount }, { data: documentsCount }, { data: midtRegistersCount }] =
      await Promise.all([
        axiosInstance.post(`${api.baseURL}user/count`,{ 
        where: {
          sourceOrganization: user?.sourceOrganization,
        }}),
        axiosInstance.post(`${api.baseURL}document/count`,{
          where: {
            source: "migs",
            sourceOrganization: user?.sourceOrganization,
          }
        }),
        axiosInstance.post(`${api.baseURL}midtregister/count`),
      ]);

    setCounters([
      {
        name: "Usuarios",
        counter: usersCount,
        link: "/app/rrhh/usuarios",
        icon: personOutline,
      },
      {
        name: "Acuerdos",
        counter: documentsCount,
        link: "/app/rrhh/acuerdos",
        icon: documentTextOutline,
      },
      {
        name: "Mi DT",
        counter: midtRegistersCount,
        link: "/app/rrhh/mi-dt",
        icon: briefcaseOutline,
      },
    ]);
  };
  useIonViewWillEnter(() => {
    fetchKpis();
  });

  useEffect(() => {
    if(counters[0].counter != "0"){
      dispatch(setUserCount(parseInt(counters[0].counter!)))
    }
  }, [counters])
  

  return (
    <IonGrid style={{ minHeight: "94px" }} class="ion-no-margin">
      <IonRow>
        {counters?.map((counterItem) => (
          <IonCol key={counterItem.name} size="12" sizeLg="4">
            <IonCard class="ion-no-margin">
              <IonItem lines="none" color="primary">
                <IonIcon icon={counterItem.icon} slot="start"></IonIcon>
                <IonLabel style={{ fontWeight: 500 }}>
                  <h2>{counterItem.name}</h2>
                  <h1>{counterItem.counter}</h1>
                </IonLabel>
                <IonButton
                  slot="end"
                  size="small"
                  color="secondary"
                  class="ion-align-self-start ion-margin-top"
                  routerLink={counterItem.link}
                >
                  Ver todos
                </IonButton>
              </IonItem>
            </IonCard>
          </IonCol>
        ))}
      </IonRow>
    </IonGrid>
  );
};

